import { createAction, props } from '@ngrx/store';
import { IAuthState } from './auth.reducers';

/************************************************************************
 *  AUTH ACTIONS
 ************************************************************************/
export const authSetAuthInfo = createAction('[Auth] Set Auth Info', props<{ authInfo: IAuthState | undefined }>());

export const authSelectAuthInfo = createAction('[Auth] Select Auth Info');

/************************************************************************
 *  Authenticated
 ************************************************************************/
export const authSelectIfAuthenticated = createAction('[Auth] Check if Authenticated');

export const authSetAuthenticated = createAction('[Auth] Set State of Authentication', props<{ authenticated: boolean }>());

/************************************************************************
 * User
 *************************************************************************/
export const authSetUserName = createAction('[Auth] Set User Name', props<{ userName: string }>());

export const authSetUserEmail = createAction('[Auth] Set User Email', props<{ email: string }>());

export const authSetOrgId = createAction('[Auth] Set Organization Id', props<{ orgId: string }>());

export const authSetOrgName = createAction('[Auth] Set Organization Name', props<{ orgName: string }>());

export const authSetUiAnalytics = createAction('[Auth] Set analytics enabling', props<{ uiAnalytics: boolean }>());

export const authSetEmailHash = createAction('[Auth] Set Email Hash in MD5 format', props<{ emailHash: string }>());

export const authSetUserType = createAction('[Auth] Set User Type', props<{ email: string }>());
/************************************************************************
 *  Last Action Activity
 ************************************************************************/
export const authSelectLastAction = createAction('[Auth] Select Last Action');

export const authSetLastAction = createAction('[Auth] Set Last Action', props<{ lastActionTime: number }>());

// Resets the auth back to initial state
export const authResetAction = createAction('[Auth] Reset Action');
